let loadPromise = null;
let loadedApiKey = null;

const SCRIPT_ID = "google-maps-places-js";

const isGooglePlacesReady = () =>
  Boolean(
    typeof window !== "undefined" &&
      window.google &&
      window.google.maps &&
      window.google.maps.places,
  );

export const ensureGoogleMapsPlacesLoaded = (apiKey, { language = "en", region = "US" } = {}) => {
  const trimmedKey = String(apiKey || "").trim();
  if (!trimmedKey) {
    return Promise.resolve(false);
  }

  if (isGooglePlacesReady()) {
    loadedApiKey = loadedApiKey || trimmedKey;
    return Promise.resolve(true);
  }

  if (loadPromise) return loadPromise;

  loadedApiKey = trimmedKey;
  loadPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", () => resolve(isGooglePlacesReady()), { once: true });
      existing.addEventListener("error", () => reject(new Error("Google Maps script failed to load")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    const params = new URLSearchParams({
      key: trimmedKey,
      libraries: "places",
      v: "weekly",
      language,
      region,
    });
    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    script.onload = () => resolve(isGooglePlacesReady());
    script.onerror = () => reject(new Error("Google Maps script failed to load"));
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const getLoadedGoogleMapsApiKey = () => loadedApiKey;

